export enum DifficultyLevel {
  ANY = 0,
  EASY = 1,
  AVERAGE = 2,
  HARD = 3,
  IMPOSSIBLE = 4,
}
